import { DistributionStatus } from '../../enums/distribution-status';
import { DeviceDistribution } from './device-distribution';
import { Distributor } from './distributor';

export class DistributionOverviewItem {
    public id: string;
    public noteId: string;
    public sectorId: string;
    public coachId: string;
    public technicalCycleId: string;
    public status: DistributionStatus;
    public distributionProgress: number;
    public distributionProgressEarly: number;
    public distributionProgressLate: number;
    public lastUpdatedAt: Date;
    public distributor: Distributor;
    public deviceDistributions: DeviceDistribution[];
    public sectorDescription: string;

    constructor();
    constructor(json: any)
    constructor(json?: DistributionOverviewItem) {
        if (json) {
            Object.assign(this, json);
            this.lastUpdatedAt = json.lastUpdatedAt ? new Date(json.lastUpdatedAt) : null;
            this.distributor = new Distributor(json.distributor);
            this.deviceDistributions = json.deviceDistributions.map((deviceDistribution: any) => new DeviceDistribution(deviceDistribution));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/distribution-overview-item.ts